/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import {
  ScorecardInner,
  ScorecardKeys,
  ScorecardState
} from '../types/scorecard';
import { AnyAction } from 'redux';

export const deafultScoreCardInner = (): ScorecardInner => ({
  data: {},
  loaded: false,
  loading: false
});

export const getDefaultScorecardState = (): ScorecardState => ({
  data: undefined,
  main: deafultScoreCardInner(),
  initiativeId: null,
  surveyId: null,
  loaded: false,
  errored: false,
  errorMessage: ''
});

const scorecard = (state = getDefaultScorecardState(), action: AnyAction): ScorecardState => {
  const lastUpdated = Date.now();
  const type: ScorecardKeys = action.tag || 'main';
  switch (action.type) {

    case actionTypes.LOADING_SCORECARD: {
      // Reset state on initiative change
      if (state.initiativeId !== action.initiativeId) {
        return {
          ...getDefaultScorecardState(),
          [type]: { ...state[type], data: {}, loaded: false, loading: true },
          initiativeId: action.initiativeId,
          tag: action.tag,
          lastUpdated,
        }
      }
      return {
        ...state,
        [type]: { ...state[type], data: {}, loaded: false, loading: true },
        initiativeId: action.initiativeId,
        tag: action.tag,
        loaded: false,
        errored: false,
        lastUpdated,
      };
    }
    case actionTypes.ERROR_SCORECARD:
      return {
        ...state,
        tag: action.tag,
        loaded: false,
        errored: true,
        lastUpdated,
        errorMessage: action.errorMessage
      };
    case actionTypes.LOADED_SCORECARD: {
      const { scorecard, initiative } = action.data;
      return {
        ...state,
        [type]: {
          ...state[type],
          data: {
            scorecard: { ...scorecard, initiativeName: initiative.name },
            initiative,
            initiativeName: initiative.name,
          },
          loaded: true,
          loading: false,
        },
        loaded: true,
        errored: false,
        lastUpdated
      };
    }
    default:
      return state;
  }
};

export default scorecard;
